import { space, tok, tokPx } from '@sunwebgroup/ui-components'
import { Icon } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { css, styled } from 'styled-components'
import { useIntl } from '@/intl'
import { NavigationByWeeksContext } from '@/scopes/prices/components/PriceTable/NavigationByWeeksContext'

interface NavigationByWeeksProps {
  children?: React.ReactNode
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0;
`

const NavigationBlock = styled.div<{ $disabled?: boolean }>`
  display: none;
  @media (min-width: ${tokPx('primitives_breakpoint_m_min')}) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: auto;
    background: ${tok('primitives_color_neutral_100')};
    border-radius: ${tokPx('primitives_corner_radius_m')};
    cursor: pointer;
    &:hover {
      background: ${tok('primitives_color_neutral_200')};
    }
  }

  ${({ $disabled }) =>
    $disabled
    && css`
      cursor: not-allowed;
      pointer-events: none;
      opacity: 0.38;
    `}
`
const NavigationBlockLeft = styled(NavigationBlock)`
  margin-right: ${space('primitives_space_6')};
`

export function NavigationByWeeks({ children }: NavigationByWeeksProps) {
  const intl = useIntl()
  const { navigateRight, navigateLeft, isNavigationLeftEnabled, isNavigationRightEnabled }
    = React.use(NavigationByWeeksContext)
  const navigateLeftHandler = () => {
    navigateLeft()
  }

  const navigateRightHandler = () => {
    navigateRight()
  }
  return (
    <Wrapper>
      <NavigationBlockLeft
        as="button"
        onClick={navigateLeftHandler}
        $disabled={!isNavigationLeftEnabled}
        tabIndex={0}
        type="button"
        aria-label={intl.formatMessage({ id: 'previous_week_aria_label' })}
      >
        <Icon glyph="ChevronLeft" />
      </NavigationBlockLeft>
      {children}
      <NavigationBlock
        as="button"
        onClick={navigateRightHandler}
        $disabled={!isNavigationRightEnabled}
        tabIndex={0}
        type="button"
        aria-label={intl.formatMessage({ id: 'next_week_aria_label' })}
      >
        <Icon glyph="ChevronRight" />
      </NavigationBlock>
    </Wrapper>
  )
}
